export enum FontWeights {
  Bold = "700",
  SemiBold = "600",
  Normal = "500",
}

export enum FontSizes {
  Big = "18px",
  Medium = "16px",
  Small = "14px",
}
